import { render } from "./GoTop.vue?vue&type=template&id=77af22f6&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=77af22f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77af22f6"]])

export default __exports__